import { render, staticRenderFns } from "./modalAddPhone.vue?vue&type=template&id=633c557a&"
import script from "./modalAddPhone.vue?vue&type=script&lang=js&"
export * from "./modalAddPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports